import axios from "axios";

var token = localStorage.getItem("token")
  ? "Token " + localStorage.getItem("token")
  : "";

const axiosInstance = axios.create();

// axiosInstance.defaults.baseURL = "http://127.0.0.1:8000/api/";
axiosInstance.defaults.baseURL = "https://tanin.com.bd/admin/index.php/api/";

export const axiosNewInstance = axios.create();
// axiosNewInstance.defaults.baseURL = "http://202.126.120.114:8585/newlicadmin";
// axiosInstance.defaults.baseURL = "http://202.126.120.114:8585/newlicadmin/api";
//axiosInstance.defaults.baseURL = "https://arnode.arena.com.bd/admin/api";

// https://arnode.arena.com.bd/admin/api/v1/get/home

export const casInstance = axios.create();
// casInstance.defaults.baseURL = "https://api.icab.org.bd/api/";
export const caversion = "v1/";
casInstance.defaults.headers.common["Authorization"] =
  "Basic Y2xpZW50LXdlYjpVQTAxMjM0NTY=";

export const version = "v1/";
export const imagePath = "v1/";

export const processMaker = axios.create();
processMaker.defaults.baseURL =
  "https://studentservices.icab.org.bd/sysworkflow/en/neoclassic/services/soap2";
processMaker.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

export const image_url = "https://tanin.com.bd/admin/";
export const host_name = "https://tanin.com.bd/";

export const encryption_salt = "LIC@222";
export const google_recaptcha_site_key =
  "6Le2E5gaAAAAADPCWtOtzWkaBwQ1jAlPtjP7XRuK";

export default axiosInstance;

// export const axiosPorichoy = axios.create();
// axiosPorichoy.defaults.headers.common["x-api-key"] = "4d2-924-5f38217fb0";
// axiosPorichoy.defaults.headers.common["Content-Type"] = "application/json";
